"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_FILES = void 0;
exports["default"] = sendFiles;
var SEND_FILES = 'WEB_CHAT/SEND_FILES';
exports.SEND_FILES = SEND_FILES;

function sendFiles(files) {
  return {
    type: SEND_FILES,
    payload: {
      files: files
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRU5EX0ZJTEVTIiwic2VuZEZpbGVzIiwiZmlsZXMiLCJ0eXBlIiwicGF5bG9hZCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NlbmRGaWxlcy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRU5EX0ZJTEVTID0gJ1dFQl9DSEFUL1NFTkRfRklMRVMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzZW5kRmlsZXMoZmlsZXMpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRU5EX0ZJTEVTLFxuICAgIHBheWxvYWQ6IHsgZmlsZXMgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRU5EX0ZJTEVTIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxVQUFVLEdBQUcscUJBQW5COzs7QUFFZSxTQUFTQyxTQUFULENBQW1CQyxLQUFuQixFQUEwQjtFQUN2QyxPQUFPO0lBQ0xDLElBQUksRUFBRUgsVUFERDtJQUVMSSxPQUFPLEVBQUU7TUFBRUYsS0FBSyxFQUFMQTtJQUFGO0VBRkosQ0FBUDtBQUlEIn0=